// Account signup types (used in user.signUpType)
export const BUSINESS = 'BUSINESS'
export const PERSONAL = 'PERSONAL'

// Account signup type options for forms/selects
export const ACCOUNT_TYPE_OPTIONS = [
  { label: 'Personal', value: PERSONAL },
  { label: 'Business', value: BUSINESS },
]
